<template>
    <div class="field is-grouped">
        <p class="control" v-if="showComment">
            <input type="text" class="input is-small" v-model="commentText"/>
        </p>
        <p class="control" v-if="!showComment">
            <input type="button" class="button is-small is-info" @click="showComment = !showComment" :value="$t('input.addComment')"/>  
        </p>
        <p class="control" v-if="showComment">
            <input type="button" class="button is-small is-success" @click="saveComment()" :value="$t('input.save')"/>  
        </p>
        <p class="control" v-if="showComment">
            <input type="button" class="button is-small is-warning" @click="showComment = false" :value="$t('input.cancel')"/>  
        </p>
         <p class="control" v-if="showComment">
            <input type="button" class="button is-small is-danger" @click="deleteComment(true)" :value="$t('input.delete')"/>  
        </p>
    </div>
</template>

<script>
import firebase from '@/firebase'

export default {
    'name': 'RegistrationComment',
    props: {
        type: String,
        day: String
    },
    data() {
        return {
            commentText: '',
            showComment: false,
            existingCommentKey: String
        }
    },
     firebase: function() { 
        const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
        const userid = JSON.parse(localStorage.getItem('profile')).user_id;
        return {
            allComments: {
                source: firebase.database().ref('/organisations/' + tenantid + '/registrationsComment/' + userid).orderByChild('date').equalTo(this.day),
                readyCallback: function () {
                    if(this.allComments && this.allComments[0] && this.allComments[0].text) {
                        this.commentText = this.allComments[0].text || ''
                        if(this.commentText) { this.showComment = true}
                    }
                }
            },
        }
    },
    methods: {
        deleteComment(hide) {
            const commentsToDelete = _.filter(this.allComments, {'date': this.day, 'type': this.type})
            _.forEach(commentsToDelete, (comment) => {
                this.$firebaseRefs.allComments.child(comment['.key']).remove()
            })
            if(hide) {
                this.showComment = false
                this.commentText = ''
                this.$snotify.warning(this.$i18n.t('notify.commentDeleted'), {
                    showProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true
                });
            }
        },
        saveComment() {
            this.deleteComment()
            const comment = {
                date: this.day,
                text: this.commentText,
                type: this.type
            }
            this.$firebaseRefs.allComments.push(comment)
            this.$snotify.success(this.$i18n.t('notify.commentSaved'), {
                showProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true
            });
        }
    }
}
</script>

<style>

</style>
